import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline"

import rockMugicsSVG from '../../inlineSVGs/rockMugicsSVG';
import noteBlueMugicsSVG from '../../inlineSVGs/noteBlueMugicsSVG';
import subLogoSVG from '../../inlineSVGs/subLogoSVG';

import './styles.css';

const About = ({ onPress, openContact, isHideContact, isHideJoin, isShowMobile, isNoText, isNoTitle }) => {
    return(
        <div id="about" className={`about-wrapper rtl ${!isShowMobile ? 'hide' : ''}`}>
            <span className="about-anchor" id="about" />
            {!isNoTitle ?
                <div className="header-wrapper">
                    <p>הי!</p>
                    <p>אז אנחנו משפחת  Mugics</p>
                </div>
            : null}
            <div className="img-wrapper">
                <SVGInline svg={rockMugicsSVG} component="i"/>
            </div>
            <div className="mugics-origin-wrapper">
                <p className="equal"> .Music + Magic = </p>
                <SVGInline svg={subLogoSVG()} component="i"/>
            </div>
            {!isNoText ?
                <div className="text-wrapper">
                    <p>
                        <span>Mugics </span>הוא מרכז תוסס המחבר


                        {/*Mugics is a lively hub connecting music lovers and makers <br/>*/}
                        {/*from all over the world.*/}
                    </p>
                    <p>מוזיקה אוהבים ויוצרים</p>
                    <p> מכל העולם.</p>
                    <p>
                        המשימה שלנו היא להפוך את עולם המוזיקה
                        {/*Our mission is to make music flow so easy*/}
                    </p>
                    <p>לזורם וקל</p>
                    <p>לזורם כל כך קל</p>
                    <p>בכל מקום</p>
                    {/*<p>Everywhere</p>*/}
                    <p>בכל עת</p>
                    {!isHideJoin ? <a onClick={onPress}>הצטרפו! בואו נעשה Mugics!</a> : null}
                    <SVGInline className="note-mugics" svg={noteBlueMugicsSVG} width="100px" component="i"/>
                </div>
                : null}
            {!isHideContact ?
                <div className="button-wrapper">
                    <button onClick={openContact}>
                        הקלק כאן ליצירת קשר עם נציג של Mugics!
                    </button>
                </div>: null
            }
        </div>
    )
};

About.propTypes = {
    onPress: PropTypes.func,
    openContactModal: PropTypes.func,
    openContact: PropTypes.func,
    isHideContact: PropTypes.bool,
    isHideJoin: PropTypes.bool,
    isShowMobile: PropTypes.bool,
    isNoText: PropTypes.bool,
    isNoTitle: PropTypes.bool
};

export default About;




// WEBPACK FOOTER //
// ./src/Components/Main/About/About.js